import React from 'react';
import { createPortal } from 'react-dom';
import { formatSecondToMinute } from '$/utils/timeUtil';
import classNames from 'classnames';
import styles from './index.module.scss';

interface AudioTimeProps {
  currentTime: number;
  totalTime: number;
  anchorRef: React.RefObject<HTMLElement>;
}

export default function AudioTime({ currentTime, totalTime, anchorRef }: AudioTimeProps) {
  const rect = anchorRef.current?.getBoundingClientRect();

  if (!rect) return null;

  return createPortal(
    <div
      className={styles.audioTime}
      style={{ top: rect.bottom + 4, left: rect.left + rect.width / 2 }}
    >
      {currentTime > 0 && (
        <>
          <div className={classNames(styles.time, styles.currentTime)}>
            {formatSecondToMinute(currentTime, 'mm:ss')}
          </div>
          <div className={styles.separator}>/</div>
        </>
      )}
      <div className={classNames(styles.time, styles.totalTime)}>
        {formatSecondToMinute(totalTime, 'mm:ss')}
      </div>
    </div>,
    document.body,
  );
}
